import { useMemo } from 'react';
import { throttleInteraction } from '../../client/utils/ui-helpers';
import { useEventListener } from '../../client/hooks/useEventListener';
import { isClient } from '../../common/utils';

/**
 * @param interval - milliseconds to throttle callbacks
 * @param callbacks - callback functions, arguments need to be bound as none are passed when called
 */
export const useMouseListeners = (
  interval: number,
  ...callbacks: Array<(...args: any[]) => void>
) => {
  const listener = useMemo(
    () =>
      throttleInteraction(() => {
        callbacks.forEach(cb => cb());
      }, interval),
    [callbacks, interval]
  );

  const target = isClient() ? document : undefined;
  useEventListener('mousedown', listener, target);
  useEventListener('mousemove', listener, target);
};
